<shared-auth-wrapper>
    <shared-confirmation>
        {{label}}
    </shared-confirmation>
</shared-auth-wrapper>